import { render, staticRenderFns } from "./ErpDlsOrder.vue?vue&type=template&id=4836bf16&scoped=true&"
import script from "./ErpDlsOrder.vue?vue&type=script&lang=js&"
export * from "./ErpDlsOrder.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ErpDlsOrder.vue?vue&type=style&index=1&id=4836bf16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836bf16",
  null
  
)

export default component.exports